// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__HB0jk","sendOtp":"AuthorizeToLogin_sendOtp__1l5_a"};